import type {PerformanceDurationContractEntry} from '../types';
import {
  panelBankSearchAppliedDuration,
  panelBankSearchFirstInputToSearchAppliedDuration,
} from './panelBankSearchMarks';

/**
 * Register every performance duration here so the observer can pair its marks.
 */
export const REGISTERED_DURATION_CONTRACT_ENTRIES: readonly PerformanceDurationContractEntry[] =
  [
    ...panelBankSearchFirstInputToSearchAppliedDuration.durationMarkEntries,
    ...panelBankSearchAppliedDuration.durationMarkEntries,
  ];
